//@ts-ignore
import FieldsEmpity from "@assets/images/empityimages/FieldsEmpity.png";

function EmptyFarm() {
  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <img src={FieldsEmpity} alt="fields-empity" />
      <p>شما هنوز هیچ زمینی در اگرویار ثبت نکرده‌اید</p>
    </div>
  );
}

export default EmptyFarm;
